<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <BilliardTableHome/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import BilliardTableHome from "@/views/business/table/billiardTableHome_new.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    BilliardTableHome,
    Footer
  },
}
</script>

<style>
</style>